// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bi-b";
export var colorBlue = "_bi-8";
export var colorDot = "_bi-0";
export var colorDotLarge = "_bi-2";
export var colorDotSmall = "_bi-1";
export var colorGreen = "_bi-7";
export var colorGrey = "_bi-3";
export var colorOrange = "_bi-5";
export var colorPink = "_bi-a";
export var colorPurple = "_bi-9";
export var colorRed = "_bi-4";
export var colorYellow = "_bi-6";